import React, { useState } from 'react';
import { Elements as StripeElements } from '@stripe/react-stripe-js';

import StripeCheckoutModal from './StripeCheckoutModal';
import { getStripeInstance, StripeInstance } from '../../../util/config';

const StripeCheckout = () => {
  const [stripeConnectAccountId, setStripeConnectAccountId] = useState(false);

  return (
    <StripeElements
      stripe={
        stripeConnectAccountId
          ? getStripeInstance(stripeConnectAccountId)
          : StripeInstance
      }
    >
      <StripeCheckoutModal
        setStripeConnectAccountId={setStripeConnectAccountId}
      />
    </StripeElements>
  );
};

export default StripeCheckout;
